import { useEffect, useState } from 'react';
import { fetchGoogleReviews } from '../services/reviewsService';

// Reads cached Google reviews from the backend `/v1/website/reviews` endpoint
// (via reviewsService). Does NOT trigger a Places API sync — that's a
// server-side/cron concern. On any fetch failure the reviews array stays empty.
export const useRecentReviews = (limit = 5) => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    fetchGoogleReviews()
      .then((data) => {
        if (cancelled) return;
        setReviews((data || []).slice(0, limit));
      })
      .catch((err) => {
        if (cancelled) return;
        setError(err);
      })
      .finally(() => {
        if (cancelled) return;
        setLoading(false);
      });
    return () => { cancelled = true; };
  }, [limit]);

  return { reviews, loading, error };
};
